import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function PaySuccess() {
    
    useEffect(() => {
        localStorage.removeItem("basket");
      }, []);

  return (
    <div className="container-lg p-0 d-flex flex-column flex-sm-row justify-content-center align-items-center my-5">
      <div className="text-center">
        <img
          src="https://cdn-icons-png.flaticon.com/512/190/190411.png"
          alt="Success"
          width="100"
          height="100"
          className="mb-4"
        />
        <h2 className="mb-3 text-success">Köszönjük a rendelésed!</h2>
        <p className="lead">
          A fizetés sikeresen megtörtént. E-mailben hamarosan visszaigazolást küldünk a rendelés részleteiről.
        </p>
        <p>
          Rendelésed feldolgozása folyamatban van, és hamarosan úton lesz hozzád!
        </p>
        <Link to="/" className="btn btn-home-primary mt-4">
          Vissza a főoldalra
        </Link>
      </div>
    </div>
  );
}

export default PaySuccess;
